export const SET_THREAD_TOPIC_NAME = 'SET_THREAD_TOPIC_NAME';
export const SET_THREAD_ID = 'SET_THREAD_ID';
export const SET_ADD_INFO = 'SET_ADD_INFO';

export interface SetThreadTopicNameAction {
  type: typeof SET_THREAD_TOPIC_NAME;
  topicName: string;
}

export interface SetThreadIdAction {
  type: typeof SET_THREAD_ID;
  threadId: string;
}

export interface SetAddIfoIdAction {
  type: typeof SET_ADD_INFO;
  addInfo: object;
}

export const setThreadTopicName = (topicName: string): SetThreadTopicNameAction => ({
  type: SET_THREAD_TOPIC_NAME,
  topicName
});

export const setThreadId = (threadId: string): SetThreadIdAction => ({
  type: SET_THREAD_ID,
  threadId
});

export const setAddIfo = (addInfo: object): SetAddIfoIdAction => ({
  type: SET_ADD_INFO,
  addInfo
});

export type ThreadActionTypes = SetThreadTopicNameAction | SetThreadIdAction | SetAddIfoIdAction;
